module.exports = __webpack_public_path__ + "img/img04.f9b311d5.png";